module.exports = __webpack_public_path__ + "assets/img/success.7035bc9f.png";